var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hoverk"},[_c('div',[_vm._v("各证券公司支持该功能情况不统一")])])
}]

export { render, staticRenderFns }